var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceptorCreado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#E2FEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 17.0007C18.8423 17.0007 20.3346 15.5083 20.3346 13.6673C20.3346 11.8264 18.8423 10.334 17.0013 10.334C15.1604 10.334 13.668 11.8264 13.668 13.6673C13.668 15.5083 15.1604 17.0007 17.0013 17.0007Z",
    stroke: "#27AE60",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6674 19.6673L21.1674 21.0007L23.6674 18.334M20.334 23.6673H12.5114C12.3223 23.6674 12.1354 23.6272 11.963 23.5495C11.7906 23.4717 11.6368 23.3582 11.5116 23.2165C11.3865 23.0748 11.2929 22.9081 11.2371 22.7274C11.1813 22.5467 11.1646 22.3563 11.188 22.1687L11.448 20.086C11.5085 19.6021 11.7436 19.157 12.1092 18.8344C12.4749 18.5118 12.9457 18.3338 13.4334 18.334H13.6674L20.334 23.6673Z",
    stroke: "#27AE60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptorCreado);
export default __webpack_public_path__ + "static/media/receptor-creado.b5adf5b97cefdc20df34fb14edf86f27.svg";
export { ForwardRef as ReactComponent };